import React, { Component } from "react";
import { BsyUtils } from "../../utils/Utils";

export default class AddCorpCoopPane extends Component{
    defaultProps = {
        checkList: [],
    }
    constructor(props) {
        super(props);
        this.state = {
            coopName: "",
            coopInputError: false,
            corpId: null,
            isCoop: props.isCoop,
            checkList: props.checkList,
            checkListDetail: props.checkListDetail,
            dock_corp_id_list: [],
            check_list_detail: [],
            selectGroup: props.selectGroup || "",
            corpList: props.corpList || {},
            corpListMap: {},
        }
        this.inputRef = React.createRef();
    }

    componentDidMount(){
        this.props.getEl && this.props.getEl(this);
        this.inputRef.current.focus();
    }

    handleChange = (event) =>{
        this.setState({
            coopInputError: event.target.value === "",
            coopName: event.target.value
        })
    }

    handleBlur = (event) =>{
        this.setState({
            coopInputError: event.target.value === "",
            coopName: event.target.value
        })
    }

    _createChangeDepartmentBubble = () =>{
        const _this = this;
        const {dock_corp_id_list, selectGroup, isCoop, checkList} = this.state;
        if(checkList.length > 0 && isCoop){
            return
        }
        if(isCoop){
            React.axios("/corp/dock/corp/list_all").then(res=>{
                const d = new window.FX.ConfirmDialog({
                    title: React.language("contact.corp.list"),
                    height: 576,
                    width: 710,
                    contentWidget: {
                        rowSize: [440],
                        colSize: [680],
                        padding: 15,
                        items: [[{
                            widgetName: "memberSelect",
                            type: "memberselectpane",

                            editable: !0,
                            memberEnable: !1,
                            hasMenuType:false,
                            departmentEnable: !1,
                            outsiderMemberEnable: !1,
                            outsiderGroupEnable: !1,
                            roleEnable: !1,
                            corpDeptEnable: !isCoop,
                            corpEnable: isCoop,
                            dynamicEnable: !1,
                            dynamicType: "set",
                            items: res.data.corp_list,
                            value: [...dock_corp_id_list,  ...checkList],
                        }]]
                    },
                    onOk: function () {
                        let dept = d.getWidgetByName("memberSelect");
                        let d1 = dept.getAllJsonValue();
                        let d2 = dept.getItems();
                        _this.setState({dock_corp_id_list: d1.dockcorpValue, check_list_detail: d2});
                        return !1;
                    }
                });
                d.show()
            })
        }else{
            React.axios("/corp/dock/corp/list").then(res=>{
                let dock_list = dock_corp_id_list;
                const d = new window.FX.ConfirmDialog({
                    title: React.language("contact.handover.list"),
                    height: 576,
                    width: 710,
                    contentWidget: {
                        rowSize: [440],
                        colSize: [680],
                        padding: 15,
                        items: [[{
                            widgetName: "memberSelect",
                            type: "memberselectpane",

                            editable: !0,
                            memberEnable: !1,
                            departmentEnable: !1,
                            outsiderMemberEnable: !1,
                            outsiderGroupEnable: !1,
                            roleEnable: !1,
                            corpDeptEnable: !isCoop,
                            corpEnable: isCoop,
                            hasMenuType:false,
                            dynamicEnable: !1,
                            dynamicType: "set",
                            itemTitle: React.language("contact.docking.people"),
                            menuItems: res.data.corp_list,
                            value: [...dock_list, ...checkList],
                        }]]
                    },
                    onOk: function () {
                        var dept = d.getWidgetByName("memberSelect");
                        var d1 = dept.getAllJsonValue();
                        let d2 = dept.getItems();
                        _this.setState({dock_corp_id_list: d1.sortValue, check_list_detail: d2});
                        return !1;
                    }
                });
                d.show()
            })
        }
    }

    render(){
        const {coopInputError, isCoop, corpList, dock_corp_id_list, checkList, check_list_detail, checkListDetail} = this.state;
        let corpListMap = {};
        let roleUserListMap = {};
        let selectList = checkList.length > 0 ? checkList : dock_corp_id_list;
        let arr = [...check_list_detail, ...checkListDetail]
        arr.map(res=>{
            corpListMap[res._id] = res;
        })
        
        
        return (
            <div className="AddCorpCoopPane">
                <div className="pane-item coopName">
                    <div className="item-label">
                        <span className="label-req">*</span>
                        <span className="label-name">{React.language('label.name')}</span>
                    </div>
                    <div className="item-cont">
                        <input ref={this.inputRef} maxLength="32" onChange={this.handleChange} className={`name-input ${coopInputError ? "error" : ""}`} onBlur={this.handleBlur} type="text" placeholder={React.language('dept.name.placeholder')} />
                    </div>
                    {coopInputError && <div className="errorTip">
                        {isCoop ? React.language('label.name.notEmpty') : React.language('contact.role.notEmpty')}
                    </div>}
                </div>
                <div className="pane-item corp">
                    <div className="item-label">
                        <span className="label-name">{isCoop ? React.language('enterprise') : React.language('contact.docking.people')}</span>
                    </div>
                    <div className="item-cont">
                        <div className={"select-list" + (checkList.length > 0 && isCoop ? ' ban' : '') } onClick={this._createChangeDepartmentBubble}>
                            {
                                (selectList && selectList.length > 0) ? selectList.map(res => {
                                    let key = res;
                                    if(res.indexOf('-') > -1){
                                        key = res.split('-')[0];
                                    }
                                    
                                    if(isCoop){
                                        let name = corpListMap[key] ? corpListMap[key].dock_corpname : "";
                                        return name ? <div className="item-content department"><i className="icon-all-corp" /><span>{name}</span></div> : ""
                                    }else{
                                        let name = corpListMap[key] ? corpListMap[key].name : "";
                                        let avatarurl = corpListMap[key] ? corpListMap[key].avatarurl : "";
                                        const bg = name ? BsyUtils.formatUserThumb(name.toString()) : '';
                                        return name ? <div className="item-content department"><div className="avatar">
                                            {avatarurl ? <img src={avatarurl} alt="" /> : <div className={`table-user-portrait-name color-${bg.color}`}><span>{bg.name}</span></div>}
                                        </div><span>{name}</span></div> : ""
                                    }
                                    
                                }) : <div className="list-empty">
                                    <span className="empty-tip">{isCoop ? React.language('label.select1') : React.language('contact.docking.people.require')}</span>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}